<template>
  <div class="price">
    <div class="price__div">
      <img
        class="img-fluid"
        src="@/assets/img/dollar.png"
        alt="icon price"
        title="icon price"
      />
      <h3 class="price__value">{{ price.price | money }}</h3>
    </div>
    <h4 class="price__session">{{ getSessionWithText }}</h4>
  </div>
</template>

<script>
export default {
  props: {
    price: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getSessionWithText() {
      return (
        this.price.session + (this.price.session > 1 ? " sessões" : " sessão")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  &__div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  &__value {
    font-size: 12px;
    font-family: "Font Semibold";
    color: var(--black);
    line-height: 1;
    margin-bottom: 0;
  }
  &__session {
    font-size: 12px;
    font-family: "Font Regular";
    color: var(--gray-dark);
    margin-bottom: 0;
  }
}
</style>
